import {ToastContainer, ToastContainerProps} from "react-toastify";
import styled, {StyledComponent} from "styled-components";
import {addToastClassName, CypressToastClassNames, ToastClassNames} from "../../../../services/toaster/toast-helpers/toast-classnames.helper";
import {OrbitTheme} from "../../../../themes/architecture/orbit-theme.interface";

/**
 * https://fkhadra.github.io/react-toastify/how-to-style#how-to-style-with-styled-components
 * Following this link there are two ways to style toast with styles components.
 * I chose the second one: "Pass css classes to props" https://fkhadra.github.io/react-toastify/how-to-style#how-to-style-with-styled-components
 * Because I am wrapping ToastContainer in a styled component, we won't be able to use the theme prop to set "dark", "light" or "colored".
 * Theme will be set by the styled-components library to OrbitTheme.
 * However, when dispatching a toast we can specify the theme in the options parameter: toast.custom(<SomeCustomContent />, {theme: "dark"});
 * default is "light"
 */
export const ToastContainerDefaultBox = styled(ToastContainer).attrs({
    className: ToastClassNames.Container + " " + CypressToastClassNames.Container,
    toastClassName: addToastClassName(ToastClassNames.Toast + " " + CypressToastClassNames.Toast),
    bodyClassName: ToastClassNames.Body,
    progressClassName: ToastClassNames.ProgressBar,
})`
    /* container's className */
    font-size: 1.4rem;
    @media only screen and (max-width: 480px) {
        // for top positioning make sure it doesn't create problems with iPhone's notch
        &.Toastify__toast-container--top-left, &.Toastify__toast-container--top-center, &.Toastify__toast-container--top-right {
            top: env(safe-area-inset-top);
        }
        &.Toastify__toast-container {
            // toastify uses 100vw which in cypress mobile gets under the vertical scroll
            width: 100%;
        }
    }
    /* how to target the close button */
    .Toastify__close-button.Toastify__close-button--light, .Toastify__close-button.Toastify__close-button--dark, button[aria-label="close"] {
        opacity: 0.9;
    }

    /* toastClassName */
    .${ToastClassNames.Toast} {
        border: 2px solid ${({theme}) => theme.colors.boxBorderLighter};
        /* When the toaster has a visible progress bar, make room for it. */
        &:has(.orbit-toast-progress-bar[aria-hidden="false"]) {
            padding-bottom: 16px;
        }
    }

    /* bodyClassName */
    .${ToastClassNames.Body} {
        padding: 0;
    }

    /* progressClassName */
    .${ToastClassNames.ProgressBar} {
        margin: 0 6px 6px 6px;
        width: calc(100% - 12px);
        border-radius: 3px;
    }
` as StyledComponent<React.ForwardRefExoticComponent<ToastContainerProps & React.RefAttributes<HTMLDivElement>>, OrbitTheme, {}, never>;
